import 'animate.css'
import { AppReducerBase, PersistType, RouteGf, ROUTES_GF_DEFAULT_PROPS, RoutesGf, WebContainer, MENU_TYPE } from 'gf-ui'
import { useMemo } from 'react'
import imgLogin from './assets/images/home-splash.jpg'
import "./assets/sass/App.scss"
import {
  Home,
  MRCategoria, MRCerca, MRHome, MRRisultato, MRScheda, MRSubcategoria,
  PDTACategoria, PDTAHome, PDTARisultato, PDTAScheda, PDTASubcategoria
} from './pages'
import Credits from './pages/Credits'
import ProfiloUtente from './pages/ProfiloUtente'
import { apiReducer } from './reducer/slice/apiSlice'
import CEFHome from './pages/cefalee/CEFHome'

const routesProps = {    
  ...ROUTES_GF_DEFAULT_PROPS,
  profiliUtenti: {
    ...ROUTES_GF_DEFAULT_PROPS.profiliUtenti,
    insertRoutes: false
  }
}

const App = () => {  
  const reducer = useMemo(() => {
    const reducer = new AppReducerBase();
    reducer.addReducer("api", apiReducer, PersistType.SESSION)    
    return reducer
  }, [])    

  const routes = useMemo(() => {
    const routes = new RoutesGf(routesProps);
    /*--------------------------------------------Home---------------------------------------------------*/
    routes.addRoute(new RouteGf("/", "home", <Home />))
    routes.addRoute(new RouteGf("/profilo-utente/edit", "home", <ProfiloUtente />))


    /** PDTA  */
    routes.addRoute(new RouteGf("/pdta/questionari", "pdtaHome", <PDTAHome />))
    routes.addRoute(new RouteGf("/pdta/questionari/scheda/nuova/modello/:ID_MA_MODELLO", "pdtaScheda", <PDTAScheda />))
    routes.addRoute(new RouteGf("/pdta/questionari/categoria/:ID_MA_CATEGORIA", "pdtaCategoria", <PDTACategoria />))
    routes.addRoute(new RouteGf("/pdta/questionari/subcategoria/:ID_MA_CATEGORIA/:ID_MA_MODELLO", "pdtaSubcategoria", <PDTASubcategoria />))
    routes.addRoute(new RouteGf("/pdta/questionari/risultato", "pdtaRisultato", <PDTARisultato />))

    /** MALATTIE RARE  */
    routes.addRoute(new RouteGf("/malattie-rare/questionari", "mrHome", <MRHome />))
    routes.addRoute(new RouteGf("/malattie-rare/questionari/scheda/nuova/modello/:ID_MA_MODELLO", "mrScheda", <MRScheda />))
    routes.addRoute(new RouteGf("/malattie-rare/questionari/categoria/:ID_MA_CATEGORIA", "mrCategoria", <MRCategoria />))
    routes.addRoute(new RouteGf("/malattie-rare/questionari/subcategoria/:ID_MA_CATEGORIA/:ID_MA_MODELLO", "mrSubcategoria", <MRSubcategoria />))
    routes.addRoute(new RouteGf("/malattie-rare/questionari/risultato", "mrRisultato", <MRRisultato />))
    routes.addRoute(new RouteGf("/malattie-rare/cerca", "mrCerca", <MRCerca />))

    /** MALATTIE RARE  */
    routes.addRoute(new RouteGf("/cefalee", "cefHome", <CEFHome />))

    return routes;
  }, [])

  return <WebContainer     
    className="vh-100"
    logoEnte={`${window.globalConfig?.url_backend_default}${window.globalConfig?.sts || 'stsInternet'}/images/layout/web/logoEnte.jpg`}    
    showLogoEnteHeader={false}
    imgLogin={imgLogin}    
    imgCredits={<>Image by <a href="https://www.freepik.com/free-vector/online-medical-conference-with-doctors_13108104.htm#query=doctors%20pc&position=0&from_view=search&track=ais&uuid=fd1e1a29-085e-481f-b8f2-e2bbc87973c2">Freepik</a></>}
    reducer={reducer}
    moduloRoutes={routes}
    credits={<Credits />}
    showMenuSidebar={true}
    showHeader={true}
    bgLogin="bg-success"
    showEditProfileBtn={true}
    menuType={MENU_TYPE.SIMPLE}
    menuSystem={false}
  />
}
export default App;